

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl, EBaseUrl } from "../../../Helper/BaseUrl";
import { toastError, toastSuccess } from "../../../Helper/ToastMessage";

export const CreateSchedulingPostAPI = createAsyncThunk("CreateSchedulingPost", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        OrderDate,
        OrderNumber,
        ScheduleDate,
        ScheduleDay,
        M_ZoneID,
        Ward_Data,
        M_PathakID,
        M_Indicator_ShiftID,
        WorkTimeTo,
        WorkTimeFrom,
        Upload_Doc,
        FileExtension,
        Area_Data,
        M_UserID,
        Flag,
        token,
        handleIsPost,
        setloader
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const formdata = new FormData();
    formdata.append("M_FinacialYearID", M_FinacialYearID);
    formdata.append("M_MonthID", M_MonthID);
    formdata.append("OrderDate", OrderDate);
    formdata.append("OrderNumber", OrderNumber);
    formdata.append("ScheduleDate", ScheduleDate);
    formdata.append("ScheduleDay", ScheduleDay);
    formdata.append("M_ZoneID", M_ZoneID);
    formdata.append("Ward_Data", Ward_Data);
    formdata.append("M_PathakID", M_PathakID);
    formdata.append("M_Indicator_ShiftID", M_Indicator_ShiftID);
    formdata.append("WorkTimeFrom", WorkTimeFrom);
    formdata.append("WorkTimeTo", WorkTimeTo);
    formdata.append("Upload_Doc", Upload_Doc);
    formdata.append("FileExtension", FileExtension);
    formdata.append("Area_Data", Area_Data);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Dashboard/Post_WEB_T_Encroach_CreateScheduling_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                setloader(false)

            } else {
                toastError(result.message)
                setloader(false)
            }
            return result
        })
})

const CreateSchedulingPostSlice = createSlice({
    name: "CreateSchedulingPost",
    initialState: {
        isloading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CreateSchedulingPostAPI.pending, (state, action) => {
            state.isloading = true;
        });
        builder.addCase(CreateSchedulingPostAPI.fulfilled, (state, action) => {
            state.isloading = false;
            state.TableData = action.payload;
        });
        builder.addCase(CreateSchedulingPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isloading = false;
            state.isError = true;
            state.TableData = null;

        });
    },
})

export const CreateSchedulingPostReducer = CreateSchedulingPostSlice.reducer

// Get Table Data
export const ViewSchedulingGetTableDataAPI = createAsyncThunk("ViewSchedulingGetTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        M_WardID,
        T_Encroach_CreateSchedulingID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        handleSetData,
        setOwnerDtails,
        setOfficerVisitCloseComplaint,
        setViewSchedulingData,
        setTodayCompletedSchedulingData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${EBaseUrl}/Dashboard/Get_WEB_T_Encroach_CreateScheduling_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&T_Encroach_CreateSchedulingID=${T_Encroach_CreateSchedulingID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    handleSetData && handleSetData(result.data.table)
                    if (Flag == "OwnerDetails") {
                        setOwnerDtails && setOwnerDtails(result.data.table)
                    }  if (Flag == "OfficerVisit_CloseComplaint" || Flag == "SocialMedia_CloseComplaint" || Flag == "SarthiPortal_CloseComplaint") {
                        setOfficerVisitCloseComplaint(result.data.table)
                    } if (Flag == "TotalScheduling" || Flag == "UpcomingScheduling" || Flag == "CompletedScheduling") {
                        setViewSchedulingData(result.data.table)
                    }if (Flag == "TodaysScheduleCompl_First" || Flag == "TodaysScheduleCompl_Second") {
                        setTodayCompletedSchedulingData(result.data.table)
                    }

                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const ViewSchedulingGetTableDataSlice = createSlice({
    name: "ViewSchedulingGetTableData",
    initialState: {
        isLoadingData: false,
        tableDataOne: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ViewSchedulingGetTableDataAPI.pending, (state, action) => {
            state.isLoadingData = true;
        });
        builder.addCase(ViewSchedulingGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoadingData = false;
            state.tableDataOne = action.payload;
        });
        builder.addCase(ViewSchedulingGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoadingData = false;
            state.isError = true;
            state.tableDataOne = null;
            toastError('Something went wrong')
        });
    },
})

export const ViewSchedulingGetTableDataReducer = ViewSchedulingGetTableDataSlice.reducer

// Get Table Data
export const WardAndAreaPopUpGetTableDataAPI = createAsyncThunk("WardAndAreaPopUpGetTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        T_Encroach_CreateSchedulingID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Dashboard/Get_WEB_T_Encroach_CreateScheduling_WardArea_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&T_Encroach_CreateSchedulingID=${T_Encroach_CreateSchedulingID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const WardAndAreaPopUpGetTableDataSlice = createSlice({
    name: "WardAndAreaPopUpGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WardAndAreaPopUpGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WardAndAreaPopUpGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WardAndAreaPopUpGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const WardAndAreaPopUpGetTableDataReducer = WardAndAreaPopUpGetTableDataSlice.reducer




